// extracted by mini-css-extract-plugin
module.exports = {"root":"Document_root__1PqFz","link":"Document_link__1hCG0","icon":"Document_icon__2Rb7e"};